import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import './index.scss';

import { CUSTOMERS_GET } from '../../../store/reducers/customer/customer-actions';

import GlobalFilterDataService from '../../../services/globalFilterDataService';

import { GLOBAL_FILTER_TYPE } from '../../../utils/enums';
import { createAction } from '../../../utils/sagaHelper';

import CustomersListHeader from '../CustomersListHeader';
import CustomersListItem from '../CustomersListItem/index.js';
import LayoutHeaderControls from '../LayoutHeaderControls/LayoutHeaderControls.jsx';
import { PrintSelectedItems } from '../SectionItemModalSelect/SectionItemModalSelect.jsx';
import IconButton from '../IconButton/IconButton.jsx';
import i18n from 'i18next';
import { isRTL } from '../../../services/userModel.js';

const CustomersListModal = ({ selectedItems, onSaveItems, getCustomers, items, handleClosePopup, isOpen, idKey }) => {
  const [filter, setFilter] = useState(GlobalFilterDataService.instance.getFilter(GLOBAL_FILTER_TYPE.customers));
  const [selectedCustomers, setSelectedCustomers] = useState(selectedItems || []);

  useEffect(() => {
    setSelectedCustomers(selectedItems)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  const handleToggleItem = item => {
    if (selectedCustomers.includes(item)) {
      setSelectedCustomers(selectedCustomers.filter(customer => customer[idKey] !== item[idKey]));
    } else {
      setSelectedCustomers([...selectedCustomers, item]);
    }
  };

  const handleOnSaveItems = () => {
    onSaveItems(selectedCustomers);
    handleClosePopup();
  };

  const handleOnSetFilter = val => {
    setFilter(val);
  };

  useEffect(() => {
    getCustomers(filter);
  }, [filter, getCustomers]);

  return (
    <div className={classNames('customersListModal', { rlt: isRTL() })}>
      <div className={classNames('ordersFilterHeader')}>
        <IconButton iconName={'crossClose'} isIcon onClick={handleClosePopup} />
      </div>
      <div className={classNames('label')}>{i18n.t('settings.campaigns.CAMPAIGN_CUSTOMERS_LIST_MODAL_LABEL')}</div>
      <CustomersListHeader withLabel={false} withExelIcon={false} filter={filter} onSetFilter={handleOnSetFilter} />
      <PrintSelectedItems selectedItems={selectedCustomers} handleDeleteItem={handleToggleItem} idKey={idKey} />
      <div className={classNames('customersListItems')}>
        {items?.map((item, i) => (
          <CustomersListItem
            key={`customersListItem-${i}`}
            value={item}
            active={selectedCustomers.includes(item)}
            onSelect={() => handleToggleItem(item)}
          />
        ))}
      </div>
      <div className={classNames('controls')}>
        <LayoutHeaderControls onSave={handleOnSaveItems} onClose={handleClosePopup} />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  items: state.customer.customers || [],
});

const mapDispatchToProps = dispatch => {
  return {
    getCustomers: data => dispatch(createAction(CUSTOMERS_GET, data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomersListModal);
